import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Financial Module Service Stores
 *
 * Only estimating/quoting service stores remain here. Accounting service stores
 * (payments, invoices, bills, GL, journals, AR/AP, reconciliations, etc.) were
 * removed; accounting is delivered separately via the `@intrasync/accounting`
 * module.
 */
export const financialStores: ServiceStoreConfig[] = [
  {
    name: "quotes",
    // API mounts this under the `financial/` namespace (quotes.ts → quotePath).
    servicePath: "financial/quotes",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "quoteId",
    },
  },
  {
    name: "quote-lines",
    // API mounts this under the `financial/` namespace (quote-lines.shared.ts).
    servicePath: "financial/quote-lines",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "quoteLineId",
    },
  },
  {
    name: "tax-rates",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      pagination: 25,
    },
  },
  {
    name: "wa-tax-lookup",
    options: {
      enableErrorNotifications: true,
    },
  },
];
